<template>
  <el-popover
    placement="bottom"
    width="860"
    trigger="hover"
    @show="getLocalOrderStat"
    @hide="onHide"
    :disabled="disabled || level == 'ad'"
    popper-class="local-order-popover"
  >
    <localOrderPop
      v-if="show"
      :level="level"
      :id="_id"
      :data="data"
      :currency="currency"
      v-loading="loading"
    ></localOrderPop>
    <div slot="reference">              
      <slot></slot>
    </div>
  </el-popover>
</template>

<script>
import localOrderPop from './localOrderPop';
export default {
  props: {
    id: String,
    level: String,
    row: Object,
    api: Function,
    platform: String,
    params: Object,
    disabled: Boolean,
    currency: String,
  },
  components: { localOrderPop },
  data() {
    return {
      localOrderStat: {},
      loading: false,
      show: false,
    };
  },
  computed: {
    data() {
      if (!this.api) {
        return this.row;
      }
      return this.localOrderStat[this._id];
    },
    _id() {
      if (this.id) return this.id;
      if (this.level == 'campaign') {
        return this.row.ad.campaignId;
      } else {
        return this.row.ad.adGroupId;
      }
    },
  },
  methods: {
    getLocalOrderStat() {
      this.show = true;

      if (this.localOrderStat[this._id] || this.localOrderStat[this._id] === null || !this.api) {
        return;
      }
      let params = {
        ...this.params,
        actId: this.row.ad.adAccountId,
        platform: this.platform,
        level: this.level,
        // daysDiff: 7, // 统计时间天数，近7天传7  近15天传15
        ids: [this._id], //广告id  如果广告层级是系列传系列id，如果是组传组id
      };
      this.loading = true;
      this.api(params)
        .then((res) => {
          this.localOrderStat = {
            ...res.data,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onHide() {
      this.show = false;
    },
  },
};
</script>
<style>
.local-order-popover {
  width: 860 !important;
  max-height: 400px !important; /* 设置你想要的固定最大高度 */
}

.local-order-popover .el-popover__content {
  max-height: 400px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
</style>
